import React from "react";
import { Button, Modal } from "react-bootstrap";
import { DeleteWarningIcon } from "../../../../../components/ui/icons";
import useEnableDisablePopup from "./useEnableDisablePopup";

interface IProps {
  orgAdminName: string;
  orgName: string;
  isEnabled: boolean;
}

const EnableDisablePopup = (props: IProps) => {
  const {
    show,
    handleClose,
    handleShow,
    popupFunctionality,
    popupTitle,
    popupContent,
    handleOrgStatusChange,
  } = useEnableDisablePopup(props);

  return (
    <>
      <div onClick={handleShow}>{popupFunctionality}</div>

      <Modal
        show={show}
        onHide={handleClose}
        className="modal-container disable-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="delete-heading">
              <DeleteWarningIcon></DeleteWarningIcon>
              <h1>{popupTitle}</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{popupContent}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-delete" onClick={handleOrgStatusChange}>
            {popupFunctionality}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EnableDisablePopup;
